
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Abendtypen leben ungesünder als Morgenmenschen. Dies wisse man aus verschiedenen Studien, sagt Christian Cajochen, Leiter des Zentrums für Chronobiologie an den Universitären Psychiatrischen Kliniken Basel. «Ihr Zigarettenkonsum ist höher, ihr Koffeinkonsum ist höher, sie leiden öfter an Depressionen, und sie haben auch ein höheres Risiko für Fettleibigkeit als Morgenmenschen.»`}<br /><br />{`
Das alles führt dazu, dass Nachtmenschen möglicherweise auch eine kürzere Lebenserwartung haben. Dies zumindest legt eine 2018 publizierte Studie nahe. Demnach hatten Personen, die sich als «eindeutige Nachtmenschen» respektive «Eulen» bezeichneten, ein um zehn Prozent höheres Risiko, innerhalb der Studiendauer von 6,5 Jahren zu sterben, als «eindeutige Morgenmenschen», sogenannte «Lerchen». Die Studie bestätigte auch, dass eindeutige Eulen ein höheres Risiko für diverse Erkrankungen haben: von Diabetes über Herz-Kreislauf-, Magen-Darm- und Atemwegs-Erkrankungen, neurologischen Problemen, Hormonstörungen, bis hin zu psychischen Leiden. Letztere traten bei Eulen fast doppelt so häufig auf wie bei Lerchen, Diabetes, ein anderes Beispiel, um 30 Prozent häufiger.`}<br /><br />{`
Das Leben als Eule hat allerdings nicht nur Nachteile. So gibt es Studien, die nahelegen, dass Eulen schlauer, kreativer und konsistenter bei der Arbeit sind als Lerchen. Man müsse bei solchen Interpretationen allerdings vorsichtig sein, sagt der Chronobiologe Cajochen, aber es habe schon etwas, dass Abendtypen kreativer sind. Nur: «Wenn Sie ein genialer Jazzmusiker sind und ein Morgentyp, dann haben Sie ein Problem», sagt der Chronobiologe. «Umgekehrt haben extreme Abendtypen, die Bäcker werden wollen, ebenfalls ein Problem.» `}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;